import styles from "./NotFound.module.scss";

export function NotFound() {
  return (
    <main className={styles.root}>
      <h1 className={styles.code}>404</h1>
      <p className={styles.message}>Not found</p>
    </main>
  );
}
